export default __webpack_public_path__ + "static/at-home_testimonial-e5267d6ce8aba073fab05cbf41c99ce8.jpg";